export default __webpack_public_path__ + "locales/sr-Latn-RS/DataReassignmentDialog.json?hash=f95c9aba7672a0b5f66d70ce86183478";